<template>
	<div class="page-accouting-ats-sales">
		<header-page actions name="page-accounting-action" :title="$route.meta.title" :button-close="openMobile"
			tabindex="-1" @click-close="closeMobile" />
		<action-bar class="action-mobile" :resource-uri="$route.name" @run-action="runAction" />
		<v-layout tabindex="-1">
			<v-flex>
				<v-alert :value="!currentSubsidiary.id" type="warning">
					Seleccione una empresa
				</v-alert>
			</v-flex>
		</v-layout>
		<div class="pt-3 px-4 show-mobile" v-if="currentSubsidiary.id">
			<v-layout row align-center wrap>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						item-text="name"
						item-value="id"
						label="Módulo"
						:height="32"
						:value="moduleId"
						:items="modules"
						@input="getDataModule($event)" />
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect
						item-text="name"
						:disabled="!moduleId"
						item-value="id"
						label="Reporte"
						:height="32"
						:value="report"
						clear
						return-object
						:items="filterTypeReports"
						@input="getTypeReports($event)" />
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<BaseSelect item-text="name" item-value="id" label="Fechas" :height="32" :items="typesDate"
						@input="getDataDate($event)" />
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<span class="captionDate">Fecha Desde</span>
					<date-component round :date="model.startDate" icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'startDate', value: $event })"></date-component>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<span class="captionDate">Fecha hasta</span>
					<date-component round :date="model.endDate" icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'endDate', value: $event })"></date-component>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<v-btn
						color="blue"
						class="ma-0 btn-accounting mt-3"
						:disabled="!moduleId"
						@click="loadModules">
						<v-icon color="white">search</v-icon>
						Buscar
					</v-btn>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<v-btn color="error" class="ma-0 mt-3 btn-accounting" @click="clearAccouting">
						<v-icon color="white">clear</v-icon>
						Limpiar
					</v-btn>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<v-btn :disabled="disabledSeeXml" color="#02979b" class="ma-0 btn-accounting mt-3"
						@click="seeXml">
						<v-icon color="white">check_circle</v-icon>
						Vizualizar XML
					</v-btn>
				</v-flex>
				<!-- <v-flex xs4 md2 pl-2 lg2>
					<v-btn :disabled="disabledDoXml" color="#2196f3" class="ma-0 btn-accounting mt-3"
						@click="DowloadXml">
						<v-icon color="white">print</v-icon>
						Descargar XML
					</v-btn>
				</v-flex> -->
				<v-flex xs4 md2 pl-2 lg2>
					<v-btn :disabled="rows.length === 0" color="#2196f3" class="ma-0 btn-accounting mt-3"
						@click="seeDetails">
						<v-icon color="white">visibility</v-icon>
						&nbsp;Detalles
					</v-btn>
				</v-flex>
				<v-flex xs4 md2 pl-2 lg2>
					<v-btn :disabled="!moduleId || !report" color="#02979b" class="ma-0 btn-accounting mt-3"
						@click="downloadReport">
						<v-icon color="white">cloud_download</v-icon>
						&nbsp;Descargar PDF
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
		<div class="row-mobile" v-if="currentSubsidiary.id && !showPDF">
			<v-layout row wrap mt-4 v-if="moduleId === 1">
				<v-flex xs12 sm12 lg6 px-2 v-if="listAccounting && !openMobile">
					<app-table
						:check-all="checkAll"
						:columns="columnsSales"
						:rows="rows"
						:items-total-quantity="itemsTotalQuantity"
						:items-quantity="rows.length"
						:last-page="lastPage"
						:caption-quantity="false"
						:input-search="false"
						:current-page="currentPage"
						:created-add="false"
						@on-search-event="onSearch"
						@on-page="changePage"
						class="scrollable-table"
					>
						<template slot="rows" slot-scope="props">
								<td  :class="{ 'selected-cell': rowId === props.row.customer.id }"  style="width: 125px;" v-show="showRow(columnsSales, 1)">
									{{
										props.row.customer.name || props.row.customer.rzSocial
									}}
									{{
										props.row.customer.lastname || ''
									}}
								</td>
								<td :class="{ 'selected-cell': rowId === props.row.customer.id }" style="width: 125px;" v-show="showRow(columnsSales, 2)" class="entity">
									{{
										props.row.customer.dni
										? props.row.customer.dni
										: props.row.customer.ruc
									}}
								</td>
								<td :class="{ 'selected-cell': rowId === props.row.customer.id }" style="width: 125px;" v-show="showRow(columnsSales, 3)">
									{{ Object.keys(props.row.sale).length !== 0 ? getTypeDocument(props.row.sale.typeDocument.id) : null }}
								</td>
								<td :class="{ 'selected-cell': rowId === props.row.customer.id }" style="width: 125px;" v-show="showRow(columnsSales, 4)">{{ props.row.count }}</td>
								<td :class="{ 'selected-cell': rowId === props.row.customer.id }" style="width: 125px;" class="col7" v-show="showRow(columnsSales, 5)">
									<app-tooltip-button color="info" icon="remove_red_eye" text="Ver Detalle"
										@click-icon="openDetail(props.row, 'sales')" />
								</td>
						</template>
					</app-table>
				</v-flex>
				<v-flex xs12 sm12 lg6 px-2 class="content-acc" :class="{ open: openMobile }">
					<v-flex xs12 class="message-box">
						<v-flex xs12>
							<iframe v-if="seePdfXml" ref="pdfViewer" :src="pdfBlobUrl"
								style="width: 100%; height: 520px;"></iframe>
						</v-flex>
						<v-flex xs12 v-if="!seePdfXml">
							<v-flex xs12 mb-1 class="wrapper-detail">
								<div class="layout justify-center content-open">
									<span>Detalle de Retenciones</span>
								</div>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-layout>
									<v-flex xs6 pa-1 class="content-label">Cliente:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet ? dataSelectedRet.customer.lastname : null
									}}
										{{
											dataSelectedRet ? dataSelectedRet.customer.name : null
										}} {{
											dataSelectedRet ? dataSelectedRet.customer.rzSocial : null
										}} </v-flex>
									<v-flex xs6 pa-1 class="content-label">Identificación:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet && dataSelectedRet.customer && dataSelectedRet.customer.dni ? dataSelectedRet.customer.dni : dataSelectedRet && dataSelectedRet.customer && dataSelectedRet.customer.ruc ? dataSelectedRet.customer.ruc : null
									}}</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-layout>
									<v-flex xs6 pa-1 class="content-label">Tipo Comprobante:</v-flex>
									<v-flex xs1 pa-1 class="content-text">{{
										dataSelectedRet && Object.keys(dataSelectedRet.sale).length !== 0 ? getTypeDocument(dataSelectedRet.sale.typeDocument.id) : null
									}}</v-flex>
									<v-flex xs5 pa-1 class="content-text">{{
										dataSelectedRet && Object.keys(dataSelectedRet.sale).length !== 0
										? dataSelectedRet.sale.typeDocument.name
										: null
									}}</v-flex>
									<v-flex xs6 pa-1 class="content-label">Nro de Comprobante:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet ? dataSelectedRet.count : null
									}}</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-layout>
									<v-flex xs6 pa-1 class="content-label">F. de Contabilización:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet && Object.keys(dataSelectedRet.sale).length !== 0 && dataSelectedRet.sale.accountingSeat
										? formatDate(dataSelectedRet.sale.accountingSeat.date)
										: null
									}}</v-flex>
									<v-flex xs6 pa-1 class="content-label">F. de Emisión:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet && dataSelectedRet.details.length
										? formatDate(dataSelectedRet.details[0].detailsCode[0].date)
										: dataSelectedRet
											? formatDate(dataSelectedRet.sale.dateEmission)
											: null
									}}</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-layout>
									<v-flex xs6 pa-1 class="content-label">Base Imp 0%:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet
										? dataSelectedRet.totalSubZero.toFixed(2)
										: null
									}}</v-flex>
									<v-flex xs6 pa-1 class="content-label">Base Imp. Grabada:</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet
										? dataSelectedRet.totalSubtotal.toFixed(2)
										: null
									}}</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-layout>
									<v-flex xs6 pa-1 class="content-label">% IVA</v-flex>
									<v-flex xs6 pa-1 class="content-text"> 15 %</v-flex>
									<v-flex xs6 pa-1 class="content-label">Monto IVA</v-flex>
									<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet
										? dataSelectedRet.totalBaseIva.toFixed(2)
										: null
									}}
									</v-flex>
								</v-layout>
							</v-flex>
							<div class="layout justify-center content-open">
								<span>Retenciones IVA</span>
							</div>
							<v-flex xs12 mb-1>
								<app-table v-if="dataSelectedRet && dataSelectedRet.details"
									:check-all="checkAll"
									:columns="columnsRetIva"
									:rows="detailsRetIva"
									:items-total-quantity="itemsTotalQuantity"
									:items-quantity="detailsRetIva.length"
									:last-page="lastPage"
									:input-search="false"
									:current-page="currentPage"
									:created-add="false"
									:caption-quantity="false"
									@on-search-event="onSearch"
									@on-page="changePage"
								>
									<template slot="rows" slot-scope="props">
										<td v-show="showRow(columnsRetIva, 1)">
											{{ props.row.baseIva }}
										</td>
										<td v-show="showRow(columnsRetIva, 2)">
											{{ props.row.code }}
										</td>
										<td v-show="showRow(columnsRetIva, 3)">
											{{ props.row.percentageTax }}
										</td>
										<td v-show="showRow(columnsRetIva, 4)">{{ props.row.totalTax }}</td>
									</template>
								</app-table>
								<div class="layout justify-center content-open">
									<span>Retenciones Renta</span>
								</div>
								<app-table v-if="dataSelectedRet && dataSelectedRet.details"
									:check-all="checkAll"
									:columns="columnsRetIva"
									:rows="detailsRetRent"
									:items-total-quantity="itemsTotalQuantity"
									:items-quantity="detailsRetRent.length"
									:last-page="lastPage"
									:input-search="false"
									:current-page="currentPage"
									:created-add="false"
									:caption-quantity="false"
									@on-search-event="onSearch"
									@on-page="changePage"
								>
									<template slot="rows" slot-scope="props">
										<td v-show="showRow(columnsRetIva, 1)">
											{{ props.row.baseSubtotal }}
										</td>
										<td v-show="showRow(columnsRetIva, 2)">
											{{ props.row.code }}
										</td>
										<td v-show="showRow(columnsRetIva, 3)">
											{{ props.row.percentageTax }}
										</td>
										<td v-show="showRow(columnsRetIva, 4)">{{ props.row.totalTax }}</td>
									</template>
								</app-table>
							</v-flex>
						</v-flex>
					</v-flex>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-4 v-if="moduleId === 2">
				<v-flex xs12 sm12 lg6 px-2 v-if="listAccounting && !openMobile">
					<app-table
						:check-all="checkAll"
						:columns="columnsPurchase"
						:rows="rows"
						:items-total-quantity="itemsTotalQuantity"
						:items-quantity="rows.length"
						:last-page="lastPage"
						:caption-quantity="false"
						:input-search="false"
						:current-page="currentPage"
						:created-add="false"
						@on-search-event="onSearch"
						@on-page="changePage"
						class="scrollable-table"
					>
						<template slot="rows" slot-scope="props">
							<td  :class="{ 'selected-cell': rowId === props.row.purchase.id }" style="width: 125px;" v-show="showRow(columnsPurchase, 1)">
								{{
									props.row.supplier.name || ''
								}}
							</td>
							<td :class="{ 'selected-cell': rowId === props.row.purchase.id }" style="width: 125px;" v-show="showRow(columnsPurchase, 2)" class="entity">
								{{
									props.row.supplier.documentNumber || ''
								}}
							</td>
							<td :class="{ 'selected-cell': rowId === props.row.purchase.id }" style="width: 125px;" class="col7" v-show="showRow(columnsPurchase, 3)">
								<app-tooltip-button
									color="info"
									icon="remove_red_eye"
									text="Ver Detalle"
									@click-icon="openDetail(props.row, 'purchases')"
								/>
							</td>
						</template>
					</app-table>
				</v-flex>
				<v-flex
					xs12
					sm12
					lg6
					px-2
					class="content-acc"
					:class="{ open: openMobile }"
				>
					<v-flex xs12 class="message-box">
						<v-flex xs12>
						<iframe v-if="seePdfXml" ref="pdfViewer" :src="pdfBlobUrl" style="width: 100%; height: 520px;"></iframe>
						</v-flex>
						<v-flex xs12 v-if="!seePdfXml">
						<v-flex xs12 mb-1 class="wrapper-detail">
							<div class="layout justify-center content-open-btn">
								<span>Detalle de Compra</span>
								<v-btn
								v-if="flagDisabled === true"
								:disabled="!dataSelectedRet"
								color="success"
								class="btnLoadExcel white--text"
								@click="loadPurchase"
							>
								Actualizar
							<v-icon right dark small>save</v-icon>
							</v-btn>
							<v-btn
								v-if="flagDisabled === false"
								:disabled="!dataSelectedRet"
								color="#2196f3"
								class="btnLoadExcel white--text"
								@click="changeFlag"
							>
								Modificar
							<v-icon right dark small>refresh</v-icon>
							</v-btn>
							</div>
						</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Sustento Tributario</v-flex>
								<v-flex xs6 pa-1 class="content-text"
									>
									<span v-if="flagDisabled === false">{{
									this.dataSelectedRet &&
									this.dataSelectedRet.purchase &&
									this.dataSelectedRet.purchase.taxSupport ?
									this.dataSelectedRet.purchase.taxSupport.description : null
								}}</span>
									<v-select
										v-if="flagDisabled === true"
										:items="listCodes"
										item-text="fullName"
										item-value="code"
										solo
										autocomplete
										hide-details
										class="filter-select shadow-inset select-autocomplete-create"
										v-model="codeSus"
										>
									</v-select> </v-flex
								>
								<v-flex xs6 pa-1 class="content-label">Proveedor</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{
									dataSelectedRet && dataSelectedRet.supplier && dataSelectedRet.supplier.name ? dataSelectedRet.supplier.name : null
								}}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Tipo de Identificación</v-flex>
								<v-flex xs6 pa-1 class="content-text"> {{
												dataSelectedRet ? dataSelectedRet.supplier.documentNumber.length > 10 ? 'RUC' : 'CI' : null
									}}</v-flex>
								<v-flex xs6 pa-1 class="content-label">Nª de Identificación</v-flex>
								<v-flex xs6 pa-1 class="content-text"
									> {{
												dataSelectedRet ? dataSelectedRet.supplier.documentNumber : null
									}}
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label"
									>Tipo Comprobante:</v-flex
								>
								<v-flex xs6 pa-1 class="content-text"> {{
												dataSelectedRet ? dataSelectedRet.purchase.typeDocument.codeTaxes  : null
									}}<span> {{
													dataSelectedRet ? dataSelectedRet.purchase.typeDocument.name: null
									}}</span></v-flex>
								<v-flex xs6 pa-1 class="content-label"
									>Serie:</v-flex
								>
								<v-flex xs6 pa-1 class="content-text">{{
									dataSelectedRet ? dataSelectedRet.purchase.serie : null
								}}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label"
									>F. de Contabilización:</v-flex
								>
								<v-flex xs6 pa-1 class="content-text">{{
										dataSelectedRet && dataSelectedRet.purchase.accountingSeat ? accountingSeat : null
								}}</v-flex>
								<v-flex xs6 pa-1 class="content-label">F. de Emisión:</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{
									dataSelectedRet && dataSelectedRet.purchase ? dateEmission : null
								}}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label"
									>F. de caducidad:</v-flex
								>
								<v-flex xs6 pa-1 class="content-text">{{
									dataSelectedRet && dataSelectedRet.purchase ? expirateEmission : null
								}}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Nª Autorizaciòn de SRI</v-flex>
								<v-flex xs6 pa-1 class="content-text">
									<v-flex xs6 pa-1 class="content-text" v-if="flagDisabled === false"
									>{{
										authorizationNumber ? authorizationNumber : null
									}}</v-flex>
							</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs8 pa-1 class="content-text" v-if="flagDisabled === true">
										<app-input-text
											class="edit-inline"
											v-if="flagDisabled === true"
											v-model="authorizationNumber"
											tabindex="2"
											:text="authorizationNumber"
											@input="setDataAuth($event)"
											></app-input-text>
									</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label"
									>Monto IVA</v-flex
								>
								<!--<v-flex xs6 pa-1 class="content-text">{{
									dataSelectedRet && dataSelectedRet.details.length && amountIva > 0 ? amountIva : (dataSelectedRet && dataSelectedRet.details.length ? dataSelectedRet.purchase.taxes : null)
								}}</v-flex>-->
								<v-flex xs6 pa-1 class="content-text">{{
									dataSelectedRet && dataSelectedRet.purchase ? dataSelectedRet.purchase.taxes.toFixed(2) : null
								}}</v-flex>
								<v-flex xs6 pa-1 class="content-label">Monto ICE</v-flex>
								<v-flex xs6 pa-1 class="content-text">0.00
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Base 0%:</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{ TaxZero ? TaxZero : null }}</v-flex>
								<v-flex xs6 pa-1 class="content-label"
									>Base Grabada:</v-flex
								>
								<v-flex xs6 pa-1 class="content-text"> {{ dataSelectedRet && dataSelectedRet.purchase ? TaxDifZero : null }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 mb-1>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Base no Grabada:</v-flex>
								<v-flex xs6 pa-1 class="content-text">0.00</v-flex>
								<v-flex xs6 pa-1 class="content-label"
									>% IVA:</v-flex
								>
								<v-flex xs6 pa-1 class="content-text"> {{ dataSelectedRet ? 12 : 0 }}</v-flex>
							</v-layout>
						</v-flex>
						<div class="layout justify-center content-open">
							<span>Retenciones Iva Bienes</span>
						</div>
						<v-flex xs12 mb-1>
							<app-table
								v-if="dataSelectedRet && dataSelectedRet.details"
								:check-all="checkAll"
								:columns="columnsRetIva"
								:rows="detailsRetIva"
								:items-total-quantity="itemsTotalQuantity"
								:items-quantity="detailsRetIva.length"
								:last-page="lastPage"
								:input-search="false"
								:current-page="currentPage"
								:created-add="false"
								:caption-quantity="false"
								@on-search-event="onSearch"
								@on-page="changePage"
							>
								<template slot="rows" slot-scope="props">
									<td v-show="showRow(columnsRetIva, 1)">
										{{ props.row.baseIva }}
									</td>
									<td v-show="showRow(columnsRetIva, 2)">
										{{ props.row.code }}
									</td>
									<td v-show="showRow(columnsRetIva, 3)">
										{{ props.row.percentageTax }}
									</td>
									<td v-show="showRow(columnsRetIva, 4)">
										{{ props.row.totalTax }}
									</td>
								</template>
							</app-table>
							<div class="layout justify-center content-open">
							<span>Retenciones Iva Servicios</span>
						</div>
						</v-flex>
						<v-flex xs12 mb-1>
							<app-table
								v-if="dataSelectedRet && dataSelectedRet.details"
								:check-all="checkAll"
								:columns="columnsRetIva"
								:rows="detailsRetServices"
								:items-total-quantity="itemsTotalQuantity"
								:items-quantity="detailsRetServices.length"
								:last-page="lastPage"
								:input-search="false"
								:current-page="currentPage"
								:created-add="false"
								:caption-quantity="false"
								@on-search-event="onSearch"
								@on-page="changePage"
							>
								<template slot="rows" slot-scope="props">
									<td v-show="showRow(columnsRetIva, 1)">
										{{ props.row.baseIva }}
									</td>
									<td v-show="showRow(columnsRetIva, 2)">
										{{ props.row.nameCodePercentage }}
									</td>
									<td v-show="showRow(columnsRetIva, 3)">
										{{ props.row.percentageTax }}
									</td>
									<td v-show="showRow(columnsRetIva, 4)">
										{{ props.row.totalTax }}
									</td>
								</template>
							</app-table>
							<div class="layout justify-center content-open">
								<span>Retenciones Renta</span>
							</div>
							<app-table
								v-if="dataSelectedRet && dataSelectedRet.details"
								:check-all="checkAll"
								:columns="columnsRetIva"
								:rows="detailsRetRent"
								:items-total-quantity="itemsTotalQuantity"
								:items-quantity="detailsRetRent.length"
								:last-page="lastPage"
								:input-search="false"
								:current-page="currentPage"
								:created-add="false"
								:caption-quantity="false"
								@on-search-event="onSearch"
								@on-page="changePage"
							>
								<template slot="rows" slot-scope="props">
									<td v-show="showRow(columnsRetIva, 1)">
										{{ (props.row.baseSubtotal + props.row.baseZero)}}
									</td>
									<td v-show="showRow(columnsRetIva, 2)">
										{{ props.row.code }}
									</td>
									<td v-show="showRow(columnsRetIva, 3)">
										{{ props.row.percentageTax }}
									</td>
									<td v-show="showRow(columnsRetIva, 4)">
										{{ props.row.totalTax }}
									</td>
								</template>
							</app-table>
						</v-flex>
					</v-flex>
				</v-flex>
				</v-flex>
			</v-layout>
		</div>
		<div ref="viewer" id="result" class="hidden-sm-and-down" style="margin: 30px;" v-show="showPDF">
			<p>Mostrar PDF</p>
		</div>
		<!--<section class="modal-filter-footer">
		<modal-sidebar-button
			:is-loading="disabledConfirm"
			success-text="Confirmar"
			@accept-button-clicked="saveAccouting"
		></modal-sidebar-button>
	</section> -->
		<v-dialog
		v-model="openModalError"
		persistent
		width="1000">
		<v-card
    class="mx-auto"
    color="white"
    dark
    max-width="1000"
  >
    <v-card-title>
		<span class="titleModal">Compras Erroneas</span>
    </v-card-title>

    <v-card-text class="headline font-weight-bold">
		<app-table
		v-if="dataError"
		:check-all="checkAll"
		:columns="columnsError"
		:rows="dataError"
		:items-quantity="dataError.length"
		:input-search="false"
		:current-page="currentPage"
		:created-add="false"
		:caption-quantity="false"
	>
		<template slot="rows" slot-scope="props">
			<td style="height: 50px; width: 65px; color: black !important;" v-show="showRow(columnsError, 1)">
				{{ (props.row.nameSupplier + props.row.idPro)}}
			</td>
			<td style="height: 50px; width: 65px; color: black !important;" v-show="showRow(columnsError, 2)">
				{{ props.row.datePurchase }}
			</td>
			<td style="height: 50px; width: 65px; color: black !important;" v-show="showRow(columnsError, 3)">
				{{ props.row.docNumber }}
			</td>
		</template>
	</app-table>
    </v-card-text>

		<v-card-actions>
          <v-spacer></v-spacer>
					<v-btn	color="red"
								class="ma-0 btn-accounting mt-3"
								@click="closeModalError"><v-icon color="white">close</v-icon>Cerrar</v-btn>
        </v-card-actions>
  </v-card>
	</v-dialog>
		<v-dialog v-model="openModalGenerateXml" persistent width="450">
			<v-card class="mx-auto" style="border-radius: 15px;" color="white" dark max-width="600">
				<v-card-title style="padding: 5px 3px 5px 20px;">
					<span style="color: gray;">Generar Archivo XML</span>
				</v-card-title>
				<v-card-text>
					<BaseInput
						:height="30"
						label="Nombre del archivo"
						v-model ="fileName"
					/>
				</v-card-text>
				<v-card-actions>
					<section class="section-actions">
						<v-btn	
							small
							block
							color="error"
							class="ma-0 btn-modal"
							@click="closeModalxml"><v-icon small color="white">close</v-icon>Cerrar</v-btn>
						<v-btn 
							small
							block
							color="success"
							:disabled="!fileName"
							class="ma-0 btn-modal"
							@click="seeXmlPurchasesSales"><v-icon small color="white">description</v-icon>Generar xml</v-btn>
					</section>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="openModal"
			persistent
			width="1180">
			<ats-sales-details
				v-if="openModal && moduleId === 1"
				:details="rows"
				@close="seeDetails">
			</ats-sales-details>
			<ats-purchases-details
				v-if="openModal && moduleId === 2"
				:details="rows"
				@close="seeDetails"
			></ats-purchases-details>
		</v-dialog>
		<v-dialog
			content-class="dialog-loading"
			max-width="300"
			persistent
			v-model="isLoading">
			<div class="container-loader">
				<label class="loading-search">
					Espere unos segundos por favor, Generando XML...
				</label>
				<div class="loader"></div>
			</div>
		</v-dialog>
		<action-sidebar
		:title="action.title"
		:value="action.value"
		:width="action.width"
		@close-modal="closeModal"
		>
		<list-history-ats
			v-if="action.code === 'history-ats'"
			:subsidiary="currentSubsidiary"
			@close-modal="closeModal"
			/>
	</action-sidebar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import actionBar from '@/components/shared/action-bar/action-bar';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appDateSelect from '@/components/shared/app-date-select';
import actionSidebar from '@/components/shared/action-sidebar';
import listHistoryAts from '@/components/list-history-ats/list-history-ats';
import BaseSelect from '@/components/shared/inputs/base-select';
import { format, subDays, endOfMonth } from 'date-fns';
import JsPDF from 'jspdf';
import helper from '@/shared/helper';
import codeSales from '@/shared/codeSales';
import codePurchases from '@/shared/codePurchases';
import codeTaxesSales from '@/shared/codeTaxesSale';
import dateComponent from '@/components/autocomplete/date-component';
import atsSalesDetails from '@/components/ats-sales/ats-sales-details';
import appInputText from '@/components/autocomplete/app-input-text';
import atsPurchasesDetails from '@/components/ats-purchases/ats-purchases-details';

const { exactDate } = helper;

async function created() {
	await this.loadData('subsidiary');
	this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
	this.model.endDate = this.$today;
	window.addEventListener('resize', this.reziseMobile);
	this.model.status = 3;
	this.reziseMobile();
	this.loadCodSusList();
}

function closeModal() {
	this.action.value = false;
	this.action.title = '';
	this.action.code = '';
}

async function loadModules() {
	const params = {
		startDate: this.model.startDate,
		endDate: this.model.endDate,
		subsidiaryId: this.currentSubsidiary.id,
	};
	if (this.moduleId === 1) {
		params.flagNtc = true;
	}
	const url = this.moduleId === 1 ? 'transactional-annexes' : 'transactional-annexes-purchases';
	({ data: this.rows } = await this.$http.get(url, { params }));
	/* this.rows = this.rows.filter((row) => {
		const ids = row.sales.map(sale => sale.id); // Obtener todos los ids
		// Verificar si hay coincidencia entre salDocumentsId y algún id
		const hasMatch = row.sales.some(sale => ids.includes(sale.salDocumentsId));
		return !hasMatch; // Eliminar el elemento si hay coincidencia
	}); */
	this.disabledSeeXml = false;
	this.showPDF = false;
	this.dataSelectedRet = null;
}

function seeDetails() {
	this.openModal = !this.openModal;
}

function getTypeDocument(typeDocumentId) {
	const voucherType = codeTaxesSales.code.find(u => u.typeDocumentId === typeDocumentId);
	return voucherType.code;
}

async function seeXml() {
	let seeXmlData = null;
	if (this.moduleId === 1) {
		const newDetails = this.rows.map((i) => {
			const typeId = codeSales.code.find(u => u.typePerson === i.customer.flagTypePerson);
			console.log('i.customer::: ', i.customer);
			let lastSale = null;
			let voucherType = null;
			if (i.flagFAC) {
				lastSale = {
					code: '18',
					altCode: 'FAC',
				};
			}
			if (i.flagNTC) {
				lastSale = {
					code: '04',
					altCode: 'NTC',
				};
			}
			if (i.flagFIN) {
				lastSale = {
					code: '18',
					altCode: 'FIN',
				};
			}
			voucherType = lastSale ? codeTaxesSales.code.find(u => u.code === lastSale.code)
				: null;
			/* if (i.customer.dni) {
				typeId = codeSales.code.find(u => u.length === i.customer.dni.length);
			}	else if (i.customer.ruc) {
				typeId = codeSales.code.find(u => u.length === i.customer.ruc.length);
			} */
			const newData = {};
			newData.tpIdClient = typeId ? typeId.code : null;
			newData.idClient = i.customer.dni || i.customer.ruc;
			newData.pSales = ['04', '05', '06'].includes(typeId.code) ? 'NO' : null;
			newData.typeDocument = voucherType ? voucherType.code : null;
			newData.typeEmission = 'F';
			newData.totalSales = i.count;
			newData.baseIvaZero = (0).toFixed(2);
			newData.taxBase = i.totalSubZero.toFixed(2);
			newData.taxBaseGrav =	i.totalSubtotal.toFixed(2);
			newData.amountIva = i.totalBaseIva.toFixed(2);
			newData.amountIce = (0).toFixed(2);
			newData.retValueIva = i.totalRetentionIva.toFixed(2);
			newData.retValueRenta = i.totalRetentionRenta.toFixed(2);
			const paymentsMethods = [];
			i.typePayments.forEach((paymentType) => {
				const paymentMethod = {}; // Creamos un objeto para representar el método de pago
				if (paymentType === 'efectivo') {
					paymentMethod.wayToPay = '01'; // Asignamos '01' a la propiedad weyTopay
				} else if (paymentType === 'TA') {
					paymentMethod.wayToPay = '19'; // Asignamos '20' a la propiedad weyTopay
				} else {
					paymentMethod.wayToPay = '20'; // Asignamos '20' a la propiedad weyTopay
				}
				paymentsMethods.push(paymentMethod); // Agregamos el objeto al array paymentsMethods
			});
			const uniquePaymentsMethods =
				paymentsMethods.filter((row, index, array) =>
					array.findIndex(w => w.wayToPay === row.wayToPay) === index);
			if (lastSale.altCode !== 'FIN') {
				if (lastSale && lastSale.altCode !== 'NTC') {
					if (lastSale.amount > 500) {
						newData.paymentMethods = [
							{
								wayToPay: '20',
							},
						];
					} else {
						newData.paymentMethods = uniquePaymentsMethods.length ? uniquePaymentsMethods : [
							{
								wayToPay: '20',
							}];
					}
				} else {
					newData.paymentMethods = null;
				}
			} else {
				newData.paymentMethods = [
					{
						wayToPay: '20',
					},
				];
			}
			return newData;
		});
		const seriesMap = new Map();
		this.rowsSales.forEach((sale) => {
			sale.sales.forEach((row) => {
				const newSubTotal = row.subtotal;
				const seriePrefix = row.serie.slice(0, 3);
				if (seriesMap.has(seriePrefix)) {
					seriesMap.set(seriePrefix, seriesMap.get(seriePrefix) + newSubTotal);
				} else {
					seriesMap.set(seriePrefix, newSubTotal);
				}
			});
		});
		const result =
			Array.from(seriesMap, ([serie, totalAmount]) =>
				({ codEstab: serie || 0, saleEstab: totalAmount.toFixed(2) }));
		const lastRecord = this.rows[this.rows.length - 1];
		const lastRecordDate = new Date(lastRecord.sale.createdAt).getFullYear();
		const lastRecordMonth = lastRecord ?
			(new Date(lastRecord.sale.createdAt).getMonth() + 1).toString().padStart(2, '0') :
			(new Date(this.model.endDate).getMonth() + 1).toString().padStart(2, '0');
		seeXmlData = {
			/* eslint-disable no-nested-ternary */
			tipoIDInformante: this.rows && this.rows.length ?
				(this.rows[0].sale.subsidiaryRuc.length > 10 ? 'R' : 'C') : 'N/A',
			/* eslint-enable no-nested-ternary */
			ruc: this.rows && this.rows.length ? this.rows[0].sale.subsidiaryRuc : 'N/A',
			rzSocial: this.rows && this.rows.length ? this.rows[0].sale.subsidiaryRzSocial.trim() : 'N/A',
			year: String(lastRecordDate),
			month: String(lastRecordMonth),
			numEstabRuc: this.rows && this.rows.length ? this.rows[0].sale.warehouseCodeTaxes : 'N/A',
			totalSales: this.rows && this.rows.length ?
				this.rows
					.reduce((accumulator, obj) => {
						// Usar un acumulador temporal para calcular el subtotal de este objeto
						const subtotal = obj.sales.reduce(
							(subAcc, sale) => (
								sale.typeDocument.code === 'NTC'
									? subAcc - sale.subtotal // Restar si el code es "NTC"
									: subAcc + sale.subtotal // Sumar en otros casos
							),
							0,
						);
						return accumulator + subtotal; // Retornar el acumulador actualizado
					}, 0)
					.toFixed(2) : (0).toFixed(2),
			iva: 'IVA',
			details: newDetails,
			wareSales: result,
		};
	} else if (this.module === 2) {
		const newDetails = this.rows.map((i) => {
			const typeIdPurchases =
				codePurchases.code.find(u => u.typePerson === i.supplier.flagTypePerson);
			const newData = {};
			newData.codSus = i.purchase.taxSupport ? i.purchase.taxSupport.code : '02';
			newData.tpIdPro = typeIdPurchases ? typeIdPurchases.code : null;
			newData.idPro = i.supplier.documentNumber;
			newData.typeProof = i.purchase.typeDocument.codeTaxes;
			newData.pPurchase = 'NO';
			newData.datePurchase = exactDate(i.purchase.dateDocument, 'DD/MM/YYYY');
			newData.estab = i.purchase.serie.slice(0, 3);
			newData.pEmission = i.purchase.serie.slice(-3);
			newData.sec = i.purchase.number;
			if (newData.sec < 9) {
				const numberOfZerosToAdd = 9 - newData.sec.length;
				const zeros = '0'.repeat(numberOfZerosToAdd);
				newData.sec = zeros + newData.sec;
			}
			newData.dateEmissionPurchase = exactDate(i.purchase.dateDocument, 'DD/MM/YYYY');
			newData.authorizationNumber = i.purchase.authorizationNumber || null;
			newData.baseNoGravIva = 0.00;
			newData.baseImp = '';
			newData.baseImpGrav = '';
			const detailTaxZero = i.purchase.details.length
				? i.purchase.details.filter(detail =>	detail.tax === 0)	: [];
			const detailsTaxDifZero = i.purchase.details.length
				? i.purchase.details.filter(detail =>	detail.tax !== 0)	: [];
			newData.baseImp = detailTaxZero.length ? detailTaxZero
				.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
			newData.baseImpGrav = detailsTaxDifZero.length ? detailsTaxDifZero
				.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
			newData.baseImpExe = 0.00;
			newData.amountIce = 0.00;
			newData.amountIva = newData.baseImpGrav === '0.00' ? '0.00' : i.purchase.taxes.toFixed(2);
			newData.valRetBien10 = 0.00;
			newData.valRetServ20 = 0.00;
			newData.valRetServ100 = 0.00;
			newData.valRetServicios = 0.00;
			newData.valRetBienes = 0.00;
			i.details.forEach((y) => {
				if (y.detailsCode.description === 'BIENES' && y.detailsCode.codeTax === '1') {
					newData.valRetBienes += Number(y.detailsCode.amountTax.toFixed(2));
				} else if (y.detailsCode.description === 'SERVICIOS' && y.detailsCode.codeTax === '2') {
					newData.valRetServicios += Number(y.detailsCode.amountTax.toFixed(2));
				} else if (y.detailsCode.description === 'SERVICIOS' && y.detailsCode.codeTax === '3') {
					newData.valRetServ100 += Number(y.detailsCode.amountTax.toFixed(2));
				}
			});
			newData.valRetServ50 = 0.00;
			newData.totbasesImpReemb = 0.00;
			if (i.supplier && i.supplier.additionalInformation
				&& i.supplier.additionalInformation.transactionTypeId === 11312) {
				newData.foreignPayment = [
					{
						paymentLocExt: '01',
						typeReg: '02',
						countryEfPayGen: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
						countryEfPay: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
						appCoDobTrib: 'NA',
						payExtSujRetNorLeg: 'NA',
					},
				];
			} else {
				newData.foreignPayment = [
					{
						paymentLocExt: '01',
						typeReg: '02',
						countryEfPayGen: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
						countryEfPay: 'NA',
						appCoDobTrib: 'NA',
						payExtSujRetNorLeg: 'NA',
					},
				];
			}
			const paymentsMethods = [];
			i.purchase.typePayments.forEach((paymentType) => {
				const paymentMethod = {}; // Creamos un objeto para representar el método de pago
				if (paymentType === 'efectivo') {
					paymentMethod.wayToPay = '01'; // Asignamos '01' a la propiedad weyTopay
				} else if (paymentType === 'TA') {
					paymentMethod.wayToPay = '19'; // Asignamos '20' a la propiedad weyTopay
				} else {
					paymentMethod.wayToPay = '20'; // Asignamos '20' a la propiedad weyTopay
				}
				paymentsMethods.push(paymentMethod); // Agregamos el objeto al array paymentsMethods
			});
			const uniquePaymentsMethods =
				paymentsMethods.filter((row, index, array) =>
					array.findIndex(w => w.wayToPay === row.wayToPay) === index);
			if (i.purchase.typeDocument.code !== 'NTC') {
				if (i.purchase.amount > 500) {
					newData.paymentMethods = [
						{
							wayToPay: '20',
						},
					];
				} else {
					newData.paymentMethods = uniquePaymentsMethods.length ? uniquePaymentsMethods : [
						{
							wayToPay: '20',
						}];
				}
			} else {
				newData.paymentMethods = null;
			}
			const detailsRet =	i.details.map((y) => {
				const newDataR = {};
				newDataR.codRet = y.code || 0;
				newDataR.baseImp = (y.baseSubtotal + y.baseZero).toFixed(2) || (0).toFixed(2);
				newDataR.percentage = y.percentageTax || 0;
				newDataR.valRet = y.totalTax.toFixed(2) || (0).toFixed(2);
				return newDataR;
			});
			newData.detailAir = detailsRet;
			newData.estabRetention = i.details.length ?
				i.details[0].detailsCode.billNumber.slice(0, 3) : null;
			newData.ptoEmiRetention = i.details.length ?
				i.details[0].detailsCode.billNumber.slice(3, 6) : null;
			newData.secRetention = i.details.length ?
				i.details[0].detailsCode.billNumber.slice(7) : null;
			if (newData.secRetention) {
				if (newData.secRetention < 9) {
					const numberOfZerosToAdd = 9 - newData.secRetention.length;
					const zeros = '0'.repeat(numberOfZerosToAdd);
					newData.secRetention = zeros + newData.secRetention;
				}
			}
			newData.autRetention = i.details.length ? i.details[0].detailsCode.authorizationNumber : null;
			newData.fechaEmiRetention = i.details.length ? exactDate(i.details[0].detailsCode.date, 'DD/MM/YYYY') : null;
			if (i.purchase.affectedInvoicePurchase) {
				newData.docModificado =
					i.purchase.affectedInvoicePurchase.typeDocument.codeTaxes || null;
				newData.estabModificado =
					i.purchase.affectedInvoicePurchase.serie.substring(0, 3) || null;
				newData.ptoEmiModificado = i.purchase.affectedInvoicePurchase.serie.slice(-3) || null;
				newData.secModificado = String(i.purchase.affectedInvoicePurchase.number || '').padStart(9, '0') || null;
				newData.autModificado = i.purchase.affectedInvoicePurchase.authorizationNumber || null;
			} else {
				newData.docModificado = null;
				newData.estabModificado = null;
				newData.ptoEmiModificado = null;
				newData.secModificado = null;
				newData.autModificado = null;
			}
			return newData;
		});
		const lastRecord = this.rows[this.rows.length - 1];
		const lastRecordDate = new Date(lastRecord.purchase.dateDocument).getFullYear();
		const lastRecordMonth = lastRecord ?
			(new Date(lastRecord.purchase.dateDocument).getMonth() + 1).toString().padStart(2, '0') :
			(new Date(this.model.endDate).getMonth() + 1).toString().padStart(2, '0');
		seeXmlData = {
			/* eslint-disable no-nested-ternary */
			tipoIDInformante: this.rows && this.rows.length ? (this.rows[0].purchase.subsidiary.ruc > 10 ? 'R' : 'C') : 'N/A',
			/* eslint-enable no-nested-ternary */
			ruc: this.rows && this.rows.length ? this.rows[0].purchase.subsidiary.ruc : 'N/A',
			rzSocial: this.rows && this.rows.length ? this.rows[0].purchase.subsidiary.rzSocial.trim() : 'N/A',
			year: String(lastRecordDate),
			month: String(lastRecordMonth),
			numEstabRuc: 'N/A',
			totalSales: this.rows && this.rows.length
				? this.rows
					.reduce((accumulator, row) => accumulator + (row.purchase.subTotal || 0), 0).toFixed(2)
				: (0).toFixed(2),
			iva: 'IVA',
			detailsPurchase: newDetails,
		};
	}
	try {
		const newData = await this.$http.post(
			`transactional-annexes-xml?customerId=${this.currentSubsidiary.customerId}&subsidiaryId=${this.currentSubsidiary.id}`,
			seeXmlData);
		const parser = new DOMParser();
		this.xmlDoc = parser.parseFromString(newData.data, 'text/xml');
		const pdfDoc = new JsPDF('p', 'pt', 'letter');
		const xmlContent = new XMLSerializer().serializeToString(this.xmlDoc);
		const lines = pdfDoc.splitTextToSize(xmlContent, pdfDoc.internal.pageSize.width - 60);
		let y = 30;
		lines.forEach((line) => {
			pdfDoc.text(line, 30, y);
			y += 20;
			if (y >= pdfDoc.internal.pageSize.height - 30) {
				pdfDoc.addPage();
				y = 30;
			}
		});
		const pdfBlob = pdfDoc.output('blob');
		this.pdfBlobUrl = URL.createObjectURL(pdfBlob);
		this.disabledDoXml = false;
		this.seePdfXml = true;
		this.showNotification('Xml generado correctamente');
	} catch (error) {
		if (error.status === 400) {
			if (error.data.message === 'RULES_NOT_FOUND') {
				this.showGenericError('No existe reglas, revise en la seccion Ats reglas sus reglas');
			}
		} else {
			this.showGenericError();
		}
	}
}
async function DowloadXml() {
	const xmlContent = new XMLSerializer().serializeToString(this.xmlDoc);
	const blob = new Blob([xmlContent], { type: 'text/xml' });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = `${this.fileName}-${this.model.startDate}-${this.model.endDate}.xml`; // Nombre del archivo
	link.click();
	URL.revokeObjectURL(url);
}

function clearAccouting() {
	this.model.moduleId = null;
	this.showAccouting = false;
	this.valuesShow = {};
	this.moduleId = null;
	this.report = null;
}

function openDetail(row, type) {
	console.log('row::: ', row);
	this.flagDisabled = false;
	this.dataSelectedRet = row;
	console.log('this.rowId::: ', this.rowId);
	console.log('this.dataSelectedRet::: ', this.dataSelectedRet);
	this.codeSus = this.dataSelectedRet &&
		this.dataSelectedRet.purchase &&
		this.dataSelectedRet.purchase.taxSupport ?
		this.dataSelectedRet.purchase.taxSupport.code : null;
	this.authorizationNumber = this.dataSelectedRet && this.dataSelectedRet.purchase &&
		this.dataSelectedRet.purchase.authorizationNumber ?
		this.dataSelectedRet.purchase.authorizationNumber : null;
	if (type === 'sales') {
		this.detailsRetIva = row.details.length
			? row.details.filter(
				detail =>
					detail.code === '1' || detail.code === '2' || detail.code === '3',
			)
			: [];
		this.detailsRetRent = row.details.length
			? row.details.filter(
				detail =>
					detail.code !== '1' && detail.code !== '2' && detail.code !== '3',
			)
			: [];
		this.rowId = row.customer.id;
	} else if (type === 'purchases') {
		this.dateEmission = exactDate(this.dataSelectedRet.purchase.dateDocument, 'DD-MM-YYYY');
		this.expirateEmission = exactDate(this.dataSelectedRet.purchase.dateDocument, 'DD-MM-YYYY');
		this.accountingSeat = this.dataSelectedRet.purchase &&
			this.dataSelectedRet.purchase.accountingSeat ?
			this.dataSelectedRet.purchase.accountingSeat : null;
		this.accountingSeat = this.accountingSeat && this.accountingSeat.date
			? exactDate(this.accountingSeat.date, 'DD-MM-YYYY')
			: null;
		this.detailsRetIva = row.details.length
			? row.details.filter(
				detail =>
					detail.code === '1' || detail.code === '2' || detail.code === '3',
			)	: [];
		this.detailsRetIva = this.detailsRetIva.length ? this.detailsRetIva.filter(
			detail =>
				detail.detailsCode.description === 'BIENES',
		)
			: [];
		this.detailsRetServices = row.details.length > 0
			? row.details.filter(
				detail =>
					detail.detailsCode.description === 'SERVICIOS',
			)
			: [];
		/* const baseBienes = this.detailsRetIva.reduce((acc, i) => acc + i.baseIva, 0);
		const baseServices = this.detailsRetServices.reduce((acc, i) => acc + i.baseIva, 0);
		this.amountIva = baseBienes + baseServices; */
		const detailTaxZero = row.purchase.details.length
			? row.purchase.details.filter(
				detail =>
					detail.tax === 0)	: [];
		const detailsTaxDifZero = row.purchase.details.length
			? row.purchase.details.filter(
				detail =>
					detail.tax === 12)	: [];
		this.TaxZero = detailTaxZero.length ? detailTaxZero
			.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
		this.TaxDifZero = detailsTaxDifZero.length ? detailsTaxDifZero
			.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
		this.detailsRetRent = row.details.length
			? row.details.filter(
				detail =>
					detail.code !== '1' && detail.code !== '2' && detail.code !== '3' && detail.code !== null,
			)	: [];
		this.sumBaseZeo = 0;
		this.sumBaseIva = 0;
		this.rowId = row.purchase.id;
		this.detailsRetRent.forEach((item) => {
			this.sumBaseZeo += item.baseZero;
			this.sumBaseIva += item.baseSubtotal;
		});
	}
	this.seePdfXml = false;
}

function changePage(page) {
	this.currentPage = page;
	this.model.page = page;
	this.loadAccounting();
	this.dataSelected = [];
}

function getDate({ value, model }) {
	if (model === 'startDate') {
		this.model.startDate = format(value, 'YYYY-MM-DD');
		this.model.endDate = format(endOfMonth(this.model.startDate), 'YYYY-MM-DD');
	} else {
		this.model.endDate = format(value, 'YYYY-MM-DD');
	}
}

function formatDate(date) {
	return exactDate(date);
}

function getDataDate(val) {
	if (val === 1) {
		this.model.startDate = this.$today;
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 2) {
		this.model.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.model.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
		this.flagDate = false;
	} else if (val === 3) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 4) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 5) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
	} else if (val === 6) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = true;
	}
}
function closeMobile() {
	this.detailJournalOpen = false;
	this.openMobile = false;
}

function destroyed() {
	window.removeEventListener('resize', this.reziseMobile);
}

async function loadCodSusList() {
	try {
		const res = await this.$httpSales.get('catalog-sunat-details-list-public/04');
		this.listCodes = res.data;
		this.listCodes = this.listCodes.map((r) => {
			const nb = { ...r };
			nb.fullName = `${r.code}-${r.description}`;
			return nb;
		});
		this.showNotification('Recursos cargados correctamente.');
		this.loadData('type-register');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
		this.showGenericError();
	}
}
function changeFlag() {
	this.flagDisabled = !this.flagDisabled;
}
async function loadPurchase() {
	try {
		const body = {
			authorizationNumber: this.authorizationNumber,
			additionalInformation: {
				supplier: {
					codeTaxes: this.codeSus,
				},
			},
		};
		await this.$httpSales.post(`purchase-documents-public/${this.dataSelectedRet.purchase.id}/update?
			subsidiaryId=${this.dataSelectedRet.purchase.subsidiary.id}&companyId=${this.dataSelectedRet.purchase.subsidiary.companyId}&
				supplierId=${this.dataSelectedRet.supplier.id}`, body);
		this.showNotification('Guardado Correctamente.');
		this.flagDisabled = false;
		this.loadModules();
		this.dataSelectedRet.purchase.taxSupport.description =
			this.listCodes.find(r => r.code === this.codeSus).description;
		this.authorizationNumber = this.authorizationNumber;
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
		this.showGenericError();
	}
}

function reziseMobile() {
	const windowWidth = window.innerWidth;
	this.mobile = windowWidth <= 768;
}

function runAction({ code }) {
	this.codeAction = code;
	if (code === 'generate-xml-sales-purchases') {
		this.openModalGenerateXml = true;
	}
	if (code === 'history-ats') {
		this.action.code = 'history-ats';
		this.action.title = 'Historial de Ats Enviados';
		this.action.width = 400;
		this.action.value = true;
	}
}

function setDataAuth(value) {
	this.authorizationNumber = value.value;
}
async function seeXmlPurchasesSales() {
	this.isLoading = true;
	const params = {
		startDate: this.model.startDate,
		endDate: this.model.endDate,
		subsidiaryId: this.currentSubsidiary.id,
		codeAction: this.codeAction,
	};
	this.flagSeeXml = true;
	try {
		({ data: this.rowsPurchases } = await this.$http.get('transactional-annexes-purchases', {
			params,
		}));
	} catch (error) {
		this.flagSeeXml = false;
		this.isLoading = false;
		if (error.status === 400) {
			if (error.data.message === 'TRANSACTIONAL_ANNEX_GENERATED_WITH_PREVIOUS_REVIEW_IN_HISTORY') {
				this.showNotification('Anexo transaccional registrado con anterioridad, revisar el historial.');
				this.openModalGenerateXml = false;
			}
		} else {
			this.showGenericError();
		}
	}
	try {
		params.flagNtc = true;
		({ data: this.rowsSales } = await this.$http.get('transactional-annexes', {
			params,
		}));
	} catch (error) {
		this.flagSeeXml = false;
		this.isLoading = false;
		if (error.status === 400) {
			if (error.data.message === 'TRANSACTIONAL_ANNEX_GENERATED_WITH_PREVIOUS_REVIEW_IN_HISTORY') {
				this.showNotification('Anexo transaccional registrado con anterioridad, revisar el historial.');
				this.openModalGenerateXml = false;
			}
		} else {
			this.showGenericError();
		}
	}
	/* this.rowsSales = this.rowsSales.filter((row) => {
		const ids = row.sales.map(sale => sale.id); // Obtener todos los ids
		// Verificar si hay coincidencia entre salDocumentsId y algún id
		const hasMatch = row.sales.some(sale => ids.includes(sale.salDocumentsId));
		return !hasMatch; // Eliminar el elemento si hay coincidencia
	}); */
	// this.rowsPurchases =
	// this.rowsPurchases.filter(row => row.purchase.authorizationNumber !== ('' || null));
	const newDetailsPurchases = this.rowsPurchases.map((i) => {
		console.log('i::: ', i);
		const typeIdPurchases =
			codePurchases.code.find(u => u.typePerson === i.supplier.flagTypePerson);
		const newData = {};
		newData.codSus = i.purchase.taxSupport ? i.purchase.taxSupport.code : '02';
		newData.tpIdPro = typeIdPurchases ? typeIdPurchases.code : null;
		newData.idPro = i.supplier.documentNumber;
		newData.docNumber = i.purchase.documentNumber;
		newData.nameSupplier = i.supplier.name || i.supplier.autocomplete;
		newData.typeProof = i.purchase.typeDocument.codeTaxes;
		newData.pPurchase = 'NO';
		newData.datePurchase = exactDate(i.purchase.dateDocument, 'DD/MM/YYYY');
		newData.estab = i.purchase.serie.slice(0, 3);
		newData.pEmission = i.purchase.serie.slice(-3);
		newData.sec = i.purchase.number;
		if (newData.sec < 9) {
			const numberOfZerosToAdd = 9 - newData.sec.length;
			const zeros = '0'.repeat(numberOfZerosToAdd);
			newData.sec = zeros + newData.sec;
		}
		newData.dateEmissionPurchase = exactDate(i.purchase.dateDocument, 'DD/MM/YYYY');
		newData.authorizationNumber = i.purchase.authorizationNumber || null;
		newData.baseNoGravIva = 0.00;
		newData.baseImp = '';
		newData.baseImpGrav = '';
		const detailTaxZero = i.purchase.details.length
			? i.purchase.details.filter(detail =>	detail.tax === 0)	: [];
		const detailsTaxDifZero = i.purchase.details.length
			? i.purchase.details.filter(detail =>	detail.tax !== 0)	: [];
		newData.baseImp = detailTaxZero.length ? detailTaxZero
			.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
		newData.baseImpGrav = detailsTaxDifZero.length ? detailsTaxDifZero
			.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
		newData.baseImpExe = 0.00;
		newData.amountIce = 0.00;
		newData.amountIva = newData.baseImpGrav === '0.00' ? '0.00' : i.purchase.taxes.toFixed(2);
		newData.valRetBien10 = 0.00;
		newData.valRetServ20 = 0.00;
		newData.valRetServ100 = 0.00;
		newData.valRetServicios = 0.00;
		newData.valRetBienes = 0.00;
		i.details.forEach((y) => {
			if (y.detailsCode.description === 'BIENES' && y.detailsCode.codeTax === '1') {
				newData.valRetBienes += Number(y.detailsCode.amountTax.toFixed(2));
			} else if (y.detailsCode.description === 'SERVICIOS' && y.detailsCode.codeTax === '2') {
				newData.valRetServicios += Number(y.detailsCode.amountTax.toFixed(2));
			} else if (y.detailsCode.description === 'SERVICIOS' && y.detailsCode.codeTax === '3') {
				newData.valRetServ100 += Number(y.detailsCode.amountTax.toFixed(2));
			}
		});
		newData.valRetServ50 = 0.00;
		newData.totbasesImpReemb = 0.00;
		if (i.supplier && i.supplier.additionalInformation
			&& i.supplier.additionalInformation.transactionTypeId === 11312) {
			newData.foreignPayment = [
				{
					paymentLocExt: '01',
					typeReg: '02',
					countryEfPayGen: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
					countryEfPay: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
					appCoDobTrib: 'NA',
					payExtSujRetNorLeg: 'NA',
				},
			];
		} else {
			newData.foreignPayment = [
				{
					paymentLocExt: '01',
					typeReg: '02',
					countryEfPayGen: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
					countryEfPay: 'NA',
					appCoDobTrib: 'NA',
					payExtSujRetNorLeg: 'NA',
				},
			];
		}
		const paymentsMethods = [];
		i.purchase.typePayments.forEach((paymentType) => {
			const paymentMethod = {}; // Creamos un objeto para representar el método de pago
			if (paymentType === 'efectivo') {
				paymentMethod.wayToPay = '01'; // Asignamos '01' a la propiedad weyTopay
			} else if (paymentType === 'TA') {
				paymentMethod.wayToPay = '19'; // Asignamos '20' a la propiedad weyTopay
			} else {
				paymentMethod.wayToPay = '20'; // Asignamos '20' a la propiedad weyTopay
			}
			paymentsMethods.push(paymentMethod); // Agregamos el objeto al array paymentsMethods
		});
		const uniquePaymentsMethods =
			paymentsMethods.filter((row, index, array) =>
				array.findIndex(w => w.wayToPay === row.wayToPay) === index);
		if (i.purchase.typeDocument.code !== 'NTC') {
			if (i.purchase.amount > 500) {
				newData.paymentMethods = [
					{
						wayToPay: '20',
					},
				];
			} else {
				newData.paymentMethods = uniquePaymentsMethods.length ? uniquePaymentsMethods : [
					{
						wayToPay: '20',
					}];
			}
		} else {
			newData.paymentMethods = null;
		}
		console.log('i.details::: ', i.details);
		const detailsRet =	i.details.map((y) => {
			console.log('y.code::: ', y.code);
			const newDataR = {};
			newDataR.codRet = y.code || (0).toFixed(2);
			newDataR.baseImp = (y.baseSubtotal + y.baseZero).toFixed(2) || (0).toFixed(2);
			newDataR.percentage = y.percentageTax || 0;
			newDataR.valRet = y.totalTax.toFixed(2) || (0).toFixed(2);
			return newDataR;
		});
		newData.detailAir = detailsRet;
		newData.estabRetention = i.details.length ?
			i.details[0].detailsCode.billNumber.slice(0, 3) : null;
		newData.ptoEmiRetention = i.details.length ?
			i.details[0].detailsCode.billNumber.slice(3, 6) : null;
		newData.secRetention = i.details.length ?
			i.details[0].detailsCode.billNumber.slice(7) : null;
		if (newData.secRetention) {
			if (newData.secRetention < 9) {
				const numberOfZerosToAdd = 9 - newData.secRetention.length;
				const zeros = '0'.repeat(numberOfZerosToAdd);
				newData.secRetention = zeros + newData.secRetention;
			}
		}
		newData.autRetention = i.details.length ? i.details[0].detailsCode.authorizationNumber : null;
		newData.fechaEmiRetention = i.details.length ? exactDate(i.details[0].detailsCode.date, 'DD/MM/YYYY') : null;
		if (i.purchase.affectedInvoicePurchase) {
			newData.docModificado =
				i.purchase.affectedInvoicePurchase.typeDocument.codeTaxes || null;
			newData.estabModificado =
				i.purchase.affectedInvoicePurchase.serie.substring(0, 3) || null;
			newData.ptoEmiModificado = i.purchase.affectedInvoicePurchase.serie.slice(-3) || null;
			newData.secModificado = String(i.purchase.affectedInvoicePurchase.number || '').padStart(9, '0') || null;
			newData.autModificado = i.purchase.affectedInvoicePurchase.authorizationNumber || null;
		} else {
			newData.docModificado = null;
			newData.estabModificado = null;
			newData.ptoEmiModificado = null;
			newData.secModificado = null;
			newData.autModificado = null;
		}
		return newData;
	});
	/* eslint-disable */
	const totalSalesCount = this.rowsSales.reduce((acc, item) => acc + item.sales.length, 0);
	const subtotalesYCodigos = this.rowsSales.flatMap((item) => {
		return item.sales.map((sale) => {
			return {
				id: Number(sale.id),
				subTotal: sale && sale.subtotal ? Number(sale.subtotal.toFixed(2)) : 0,
				typeDocumentCode: sale && sale.typeDocument ? sale.typeDocument.code : null,
			};
		});
	});
	const conteo = subtotalesYCodigos.reduce(
		(acc, item) => {
			if (item.typeDocumentCode === 'NTC') {
				acc.ntcCount += 1; // Incrementar el contador de 'NTC'
			} else if (item.typeDocumentCode === 'FAC') {
				acc.facCount += 1; // Incrementar el contador de 'FAC'
			}
			return acc;
		},
		{ ntcCount: 0, facCount: 0 }, // Inicializar los contadores
	);
	/* eslint-enable */
	let total2 = 0;
	console.log('conteo::: ', conteo);
	subtotalesYCodigos.forEach((item) => {
		if (item.typeDocumentCode !== 'NTC') {
			console.log('item.id:::', item.id);
			console.log('item.typeDocumentCode::: ', item.typeDocumentCode);
			console.log('total2::: ', total2);
			console.log('Number(item.subTotal.toFixed(2))1::: ', Number(item.subTotal.toFixed(2)));
			total2 += Number(item.subTotal.toFixed(2)); // Restar si es 'NTC'
		} else {
			console.log('item2.id:::', item.id);
			console.log('item.typeDocumentCode2::: ', item.typeDocumentCode);
			console.log('total3::: ', total2);
			console.log('Number(item.subTotal.toFixed(2))2::: ', Number(item.subTotal.toFixed(2)));
			total2 -= Number(item.subTotal.toFixed(2)); // Sumar en otros casos
		}
	});
	console.log('Total de subTotal:', total2);
	const salesIds = this.rowsSales.flatMap(item => item.sales.map(sale => sale.id));
	console.log('salesIds::: ', JSON.stringify(salesIds));
	console.log('salesIds2::: ', JSON.stringify(salesIds.length));
	console.log('Total de registros en sales:', totalSalesCount);
	const newDetailsSales = this.rowsSales.map((i) => {
		console.log('i::: ', i.sale);
		const typeId = codeSales.code.find(u => u.typePerson === i.customer.flagTypePerson);
		let lastSale = null;
		let voucherType = null;
		if (i.flagFAC) {
			lastSale = {
				code: '18',
				altCode: 'FAC',
			};
		}
		if (i.flagNTC) {
			lastSale = {
				code: '04',
				altCode: 'NTC',
			};
		}
		if (i.flagFIN) {
			lastSale = {
				code: '18',
				altCode: 'FIN',
			};
		}
		voucherType = lastSale ? codeTaxesSales.code.find(u => u.code === lastSale.code)
			: null;
		console.log('lastSale::: ', lastSale);
		const newData = {};
		newData.tpIdClient = typeId ? typeId.code : null;
		newData.idClient = i.customer.dni || i.customer.ruc;
		newData.pSales = ['04', '05', '06'].includes(typeId.code) ? 'NO' : null;
		newData.typeDocument = voucherType ? voucherType.code : null;
		newData.typeEmission = 'F';
		newData.totalSales = i.count;
		newData.baseIvaZero = (0).toFixed(2);
		newData.taxBase = i.totalSubZero.toFixed(2);
		newData.taxBaseGrav = i.totalSubtotal.toFixed(2);
		newData.amountIva = i.totalBaseIva.toFixed(2);
		newData.amountIce = (0).toFixed(2);
		newData.retValueIva = i.totalRetentionIva.toFixed(2);
		newData.retValueRenta = i.totalRetentionRenta.toFixed(2);
		const paymentsMethods = [];
		i.typePayments.forEach((paymentType) => {
			const paymentMethod = {}; // Creamos un objeto para representar el método de pago
			if (paymentType === 'efectivo') {
				paymentMethod.wayToPay = '01'; // Asignamos '01' a la propiedad weyTopay
			} else if (paymentType === 'TA') {
				paymentMethod.wayToPay = '19'; // Asignamos '20' a la propiedad weyTopay
			} else {
				paymentMethod.wayToPay = '20'; // Asignamos '20' a la propiedad weyTopay
			}
			paymentsMethods.push(paymentMethod); // Agregamos el objeto al array paymentsMethods
		});
		const uniquePaymentsMethods =
			paymentsMethods.filter((row, index, array) =>
				array.findIndex(w => w.wayToPay === row.wayToPay) === index);
		if (lastSale.altCode !== 'FIN') {
			if (lastSale && lastSale.altCode !== 'NTC') {
				if (lastSale.amount > 500) {
					newData.paymentMethods = [
						{
							wayToPay: '20',
						},
					];
				} else {
					newData.paymentMethods = uniquePaymentsMethods.length ? uniquePaymentsMethods : [
						{
							wayToPay: '20',
						}];
				}
			} else {
				newData.paymentMethods = null;
			}
		} else {
			newData.paymentMethods = [
				{
					wayToPay: '20',
				},
			];
		}
		return newData;
	});
	const seriesMap = new Map();
	const totalSum = this.rowsSales.reduce((sum, i) => sum + i.totalBaseIva, 0);
	console.log('Total General:', totalSum.toFixed(2));
	this.rowsSales.forEach((sale) => {
		sale.sales.forEach((row) => {
			const newSubTotal = row.subtotal;
			const seriePrefix = row.serie.slice(0, 3);

			// Verificar si el documento tiene código "NTC" para sumar o restar
			const adjustment = row.typeDocument.code === 'NTC' ? -newSubTotal : newSubTotal;

			if (seriesMap.has(seriePrefix)) {
				seriesMap.set(seriePrefix, seriesMap.get(seriePrefix) + adjustment);
			} else {
				seriesMap.set(seriePrefix, adjustment);
			}
		});
	});
	console.log('seriesMap::: ', seriesMap);
	const result =
		Array.from(seriesMap, ([serie, totalAmount]) =>
			({ codEstab: serie || 0, saleEstab: totalAmount.toFixed(2) }));
	console.log('result::: ', result);
	const lastRecord = this.rowsSales[this.rowsSales.length - 1];
	const lastRecordDate = lastRecord ?
		new Date(lastRecord.sale.createdAt).getFullYear() :	new Date(this.model.endDate).getFullYear();
	const lastRecordMonth = lastRecord ?
		(new Date(lastRecord.sale.createdAt).getMonth() + 1).toString().padStart(2, '0') :
		(new Date(this.model.endDate).getMonth() + 1).toString().padStart(2, '0');
	const seeXmlData = this.rowsSales.length > 0 || this.rowsPurchases.length > 0 ?
		{
			/* eslint-disable no-nested-ternary */
			tipoIDInformante: this.rowsSales && this.rowsSales.length ?
				(this.rowsSales[0].sale.subsidiaryRuc.length > 10 ? 'R' : 'C') : this.rowsPurchases[0].purchase.subsidiary.ruc.length > 10 ? 'R' : 'C',
			/* eslint-enable no-nested-ternary */
			ruc: this.rowsSales && this.rowsSales.length ?
				this.rowsSales[0].sale.subsidiaryRuc :
				this.rowsPurchases[0].purchase.subsidiary.ruc,
			rzSocial: this.rowsSales && this.rowsSales.length ?
				this.rowsSales[0].sale.subsidiaryRzSocial.trim() :
				this.rowsPurchases[0].purchase.subsidiary.rzSocial.trim(),
			year: String(lastRecordDate),
			month: String(lastRecordMonth),
			numEstabRuc: this.rowsSales && this.rowsSales.length
				? this.rowsSales[0].sale.warehouseCodeTaxes :
				this.rowsPurchases[0].purchase.subsidiary.sucursalCode,
			totalSales: this.rowsSales && this.rowsSales.length ?
				this.rowsSales
					.reduce((accumulator, obj) => {
						// Usar un acumulador temporal para calcular el subtotal de este objeto
						const subtotal = obj.sales.reduce(
							(subAcc, sale) => (
								sale.typeDocument.code === 'NTC'
									? subAcc - sale.subtotal // Restar si el code es "NTC"
									: subAcc + sale.subtotal // Sumar en otros casos
							),
							0,
						);
						return accumulator + subtotal; // Retornar el acumulador actualizado
					}, 0)
					.toFixed(2) : (0).toFixed(2),
			iva: 'IVA',
			detailsPurchase: newDetailsPurchases,
			details: newDetailsSales,
			wareSales: result,
			relationsPurchaseId: this.rowsPurchases.length > 0
				? this.rowsPurchases.map(item => item.purchase.id) : [],
			// [...new Set(this.rowsPurchases.flatMap(item => item.purchase.details.map(p => p.id)))],
			relationsSalesId: this.rowsSales.length > 0
				? [...new Set(this.rowsSales.flatMap(item => item.sales.map(sale => sale.id)))] : [],
			// relationsSalesRetencionId,
			// relationsPurchaseRetencionId,
		} : {};
	try {
		const newParams = {
			customerId: this.currentSubsidiary.customerId,
			subsidiaryId: this.currentSubsidiary.id,
			startDate: this.model.startDate,
			endDate: this.model.endDate,
			companyIdApi: this.rowsPurchases.length > 0
				? this.rowsPurchases[0].purchase.subsidiary.companyId
				: this.rowsSales[0].sale.comCompanyId,
			subsidiaryIdApi: this.rowsPurchases.length > 0
				? this.rowsPurchases[0].purchase.subsidiary.id
				: this.rowsSales[0].sale.comSubsidiaryId,
			codeAction: this.codeAction,
		};
		const newData = await this.$http.post('transactional-annexes-xml', seeXmlData, { params: newParams });
		const verify = this.verifyDowloadXml(seeXmlData);
		console.log('newData::: ', newData);
		if (verify) {
			const parser = new DOMParser();
			console.log('newData::: ', newData);
			this.xmlDoc = parser.parseFromString(newData.data, 'text/xml');
			const pdfDoc = new JsPDF('p', 'pt', 'letter');
			const xmlContent = new XMLSerializer().serializeToString(this.xmlDoc);
			const lines = pdfDoc.splitTextToSize(xmlContent, pdfDoc.internal.pageSize.width - 60);
			let y = 30;
			lines.forEach((line) => {
				pdfDoc.text(line, 30, y);
				y += 20;
				if (y >= pdfDoc.internal.pageSize.height - 30) {
					pdfDoc.addPage();
					y = 30;
				}
			});
			const pdfBlob = pdfDoc.output('blob');
			this.pdfBlobUrl = URL.createObjectURL(pdfBlob);
			this.flagSeeXml = false;
			this.DowloadXml();
		} else {
			this.flagSeeXml = false;
			this.openModalError = true;
		}
	} catch (error) {
		if (error.status === 400) {
			if (error.data.message === 'RULES_NOT_FOUND') {
				this.showGenericError('No existe reglas, revise en la seccion Ats reglas sus reglas');
			} else if (error.data.message === 'TRANSACTIONAL_ANNEX_GENERATED_WITH_PREVIOUS_REVIEW_IN_HISTORY') {
				this.showNotification('Anexo transaccional registrado con anterioridad, revisar el historial.');
				this.openModalGenerateXml = false;
			}
		} else {
			this.flagSeeXml = false;
			this.showGenericError();
		}
	} finally {
		this.isLoading = false;
		this.closeModalxml();
	}
}
function verifyDowloadXml(seeXmlData) {
	let sum = 0;
	seeXmlData.detailsPurchase.forEach((row) => {
		if (row.authorizationNumber === null) {
			sum += 1;
			this.dataError.push(row);
		}
		return sum;
	});
	if (sum > 0) {
		return false;
	}
	return true;
}
function closeModalxml() {
	this.openModalGenerateXml = false;
	this.fileName = '';
	this.codeAction = null;
}
function closeModalError() {
	this.openModalError = !this.openModalError;
}

function getDataModule(value) {
	this.moduleId = value;
	this.rows = [];
	this.dataSelectedRet = null;
	this.report = null;
	if (value === 1) {
		this.filterTypeReports = this.typeReports.filter(t => t.id === 1 || t.id === 2);
	} else if (value === 2) {
		this.filterTypeReports = this.typeReports.filter(t => t.id === 3 || t.id === 4);
	}
}

function getTypeReports(value) {
	this.report = value;
}

async function downloadReport() {
	const newParams = {
		startDate: this.model.startDate,
		endDate: this.model.endDate,
		subsidiaryId: this.currentSubsidiary.id,
		// codeAction: this.codeAction,
	};
	if (this.moduleId === 1) {
		newParams.flagNtc = true;
	}
	const url = this.moduleId === 1 ? 'transactional-annexes' : 'transactional-annexes-purchases';
	let responseByModule = null;
	try {
		({ data: responseByModule } = await this.$http.get(url, { params: newParams }));
		if (responseByModule.length > 0) {
			let newDetails = null;
			if (this.moduleId === 1) {
				newDetails = responseByModule.map((i) => {
					const typeId = codeSales.code
						.find(u => u.typePerson === i.customer.flagTypePerson);
					let lastSale = null;
					let voucherType = null;
					if (i.flagFAC) {
						lastSale = {
							code: '18',
							altCode: 'FAC',
						};
					}
					if (i.flagNTC) {
						lastSale = {
							code: '04',
							altCode: 'NTC',
						};
					}
					if (i.flagFIN) {
						lastSale = {
							code: '18',
							altCode: 'FIN',
						};
					}
					voucherType = lastSale ? codeTaxesSales.code.find(u => u.code === lastSale.code)
						: null;
					const newData = {};
					newData.tpIdClient = typeId ? typeId.code : null;
					newData.idClient = i.customer.dni || i.customer.ruc;
					newData.pSales = ['04', '05', '06'].includes(typeId.code) ? 'NO' : null;
					newData.typeDocument = voucherType ? voucherType.code : null;
					newData.typeEmission = 'F';
					newData.totalSales = i.count;
					newData.baseIvaZero = (0).toFixed(2);
					newData.taxBase = i.totalSubZero.toFixed(2);
					newData.taxBaseGrav = i.totalSubtotal.toFixed(2);
					newData.amountIva = i.totalBaseIva.toFixed(2);
					newData.amountIce = (0).toFixed(2);
					newData.retValueIva = i.totalRetentionIva.toFixed(2);
					newData.retValueRenta = i.totalRetentionRenta.toFixed(2);
					const paymentsMethods = [];
					i.typePayments.forEach((paymentType) => {
						const paymentMethod = {}; // Creamos un objeto para representar el método de pago
						if (paymentType === 'efectivo') {
							paymentMethod.wayToPay = '01'; // Asignamos '01' a la propiedad weyTopay
						} else if (paymentType === 'TA') {
							paymentMethod.wayToPay = '19'; // Asignamos '20' a la propiedad weyTopay
						} else {
							paymentMethod.wayToPay = '20'; // Asignamos '20' a la propiedad weyTopay
						}
						paymentsMethods.push(paymentMethod); // Agregamos el objeto al array paymentsMethods
					});
					const uniquePaymentsMethods =
						paymentsMethods.filter((row, index, array) =>
							array.findIndex(w => w.wayToPay === row.wayToPay) === index);
					if (lastSale.altCode !== 'FIN') {
						if (lastSale && lastSale.altCode !== 'NTC') {
							if (lastSale.amount > 500) {
								newData.paymentMethods = [
									{
										wayToPay: '20',
									},
								];
							} else {
								newData.paymentMethods = uniquePaymentsMethods.length ? uniquePaymentsMethods : [
									{
										wayToPay: '20',
									}];
							}
						} else {
							newData.paymentMethods = null;
						}
					} else {
						newData.paymentMethods = [
							{
								wayToPay: '20',
							},
						];
					}
					newData.customer = i.customer || {};
					newData.sales = i.customer.flagFinancialInstitution === 0 ? i.sales : [i.sale];
					return newData;
				});
			} else if (this.moduleId === 2) {
				newDetails = responseByModule.map((i) => {
					const typeIdPurchases =
						codePurchases.code.find(u => u.typePerson === i.supplier.flagTypePerson);
					const newData = {};
					newData.purchase = i.purchase;
					newData.codSus = i.purchase.taxSupport ? i.purchase.taxSupport.code : '02';
					newData.tpIdPro = typeIdPurchases ? typeIdPurchases.code : null;
					newData.idPro = i.supplier.documentNumber;
					newData.docNumber = i.purchase.documentNumber;
					newData.nameSupplier = i.supplier.name || i.supplier.autocomplete;
					newData.typeProof = i.purchase.typeDocument.codeTaxes;
					newData.pPurchase = 'NO';
					newData.datePurchase = exactDate(i.purchase.dateDocument, 'DD/MM/YYYY');
					newData.estab = i.purchase.serie.slice(0, 3);
					newData.pEmission = i.purchase.serie.slice(-3);
					newData.sec = i.purchase.number;
					if (newData.sec < 9) {
						const numberOfZerosToAdd = 9 - newData.sec.length;
						const zeros = '0'.repeat(numberOfZerosToAdd);
						newData.sec = zeros + newData.sec;
					}
					newData.dateEmissionPurchase = exactDate(i.purchase.dateDocument, 'DD/MM/YYYY');
					newData.authorizationNumber = i.purchase.authorizationNumber || null;
					newData.baseNoGravIva = 0.00;
					newData.baseImp = '';
					newData.baseImpGrav = '';
					const detailTaxZero = i.purchase.details.length
						? i.purchase.details.filter(detail =>	detail.tax === 0)	: [];
					const detailsTaxDifZero = i.purchase.details.length
						? i.purchase.details.filter(detail =>	detail.tax !== 0)	: [];
					newData.baseImp = detailTaxZero.length ? detailTaxZero
						.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
					newData.baseImpGrav = detailsTaxDifZero.length ? detailsTaxDifZero
						.reduce((acc, obj) => acc + obj.subtotalWithoutTax, 0).toFixed(2) : (0).toFixed(2);
					newData.baseImpExe = 0.00;
					newData.amountIce = 0.00;
					newData.amountIva = newData.baseImpGrav === '0.00' ? '0.00' : i.purchase.taxes.toFixed(2);
					newData.valRetBien10 = 0.00;
					newData.valRetServ20 = 0.00;
					newData.valRetServ100 = 0.00;
					newData.valRetServicios = 0.00;
					newData.valRetBienes = 0.00;
					i.details.forEach((y) => {
						if (y.detailsCode.description === 'BIENES' && y.detailsCode.codeTax === '1') {
							newData.valRetBienes += Number(y.detailsCode.amountTax.toFixed(2));
						} else if (y.detailsCode.description === 'SERVICIOS' && y.detailsCode.codeTax === '2') {
							newData.valRetServicios += Number(y.detailsCode.amountTax.toFixed(2));
						} else if (y.detailsCode.description === 'SERVICIOS' && y.detailsCode.codeTax === '3') {
							newData.valRetServ100 += Number(y.detailsCode.amountTax.toFixed(2));
						}
					});
					newData.valRetServ50 = 0.00;
					newData.totbasesImpReemb = 0.00;
					if (i.supplier && i.supplier.additionalInformation
						&& i.supplier.additionalInformation.transactionTypeId === 11312) {
						newData.foreignPayment = [
							{
								paymentLocExt: '01',
								typeReg: '02',
								countryEfPayGen: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
								countryEfPay: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
								appCoDobTrib: 'NA',
								payExtSujRetNorLeg: 'NA',
							},
						];
					} else {
						newData.foreignPayment = [
							{
								paymentLocExt: '01',
								typeReg: '02',
								countryEfPayGen: i.supplier.country ? i.supplier.country.codeCountrySri : '593',
								countryEfPay: 'NA',
								appCoDobTrib: 'NA',
								payExtSujRetNorLeg: 'NA',
							},
						];
					}
					const paymentsMethods = [];
					i.purchase.typePayments.forEach((paymentType) => {
						const paymentMethod = {}; // Creamos un objeto para representar el método de pago
						if (paymentType === 'efectivo') {
							paymentMethod.wayToPay = '01'; // Asignamos '01' a la propiedad weyTopay
						} else if (paymentType === 'TA') {
							paymentMethod.wayToPay = '19'; // Asignamos '20' a la propiedad weyTopay
						} else {
							paymentMethod.wayToPay = '20'; // Asignamos '20' a la propiedad weyTopay
						}
						paymentsMethods.push(paymentMethod); // Agregamos el objeto al array paymentsMethods
					});
					const uniquePaymentsMethods =
						paymentsMethods.filter((row, index, array) =>
							array.findIndex(w => w.wayToPay === row.wayToPay) === index);
					if (i.purchase.typeDocument.code !== 'NTC') {
						if (i.purchase.amount > 500) {
							newData.paymentMethods = [
								{
									wayToPay: '20',
								},
							];
						} else {
							newData.paymentMethods = uniquePaymentsMethods.length ? uniquePaymentsMethods : [
								{
									wayToPay: '20',
								}];
						}
					} else {
						newData.paymentMethods = null;
					}
					const detailsRet =	i.details.map((y) => {
						const newDataR = {};
						newDataR.codRet = y.code || (0).toFixed(2);
						newDataR.baseImp = (y.baseSubtotal + y.baseZero).toFixed(2) || (0).toFixed(2);
						newDataR.percentage = y.percentageTax || 0;
						newDataR.valRet = y.totalTax.toFixed(2) || (0).toFixed(2);
						return newDataR;
					});
					newData.detailAir = detailsRet;
					newData.estabRetention = i.details.length ?
						i.details[0].detailsCode.billNumber.slice(0, 3) : null;
					newData.ptoEmiRetention = i.details.length ?
						i.details[0].detailsCode.billNumber.slice(3, 6) : null;
					newData.secRetention = i.details.length ?
						i.details[0].detailsCode.billNumber.slice(7) : null;
					if (newData.secRetention) {
						if (newData.secRetention < 9) {
							const numberOfZerosToAdd = 9 - newData.secRetention.length;
							const zeros = '0'.repeat(numberOfZerosToAdd);
							newData.secRetention = zeros + newData.secRetention;
						}
					}
					newData.autRetention = i.details.length
						? i.details[0].detailsCode.authorizationNumber : null;
					newData.fechaEmiRetention = i.details.length
						? exactDate(i.details[0].detailsCode.date, 'DD/MM/YYYY') : null;
					return newData;
				});
			}
			const params = {
				responseType: 'blob',
				params: {
					customerId: this.currentSubsidiary.customerId,
					subsidiaryId: this.currentSubsidiary.id,
					startDate: this.model.startDate,
					endDate: this.model.endDate,
					companyIdApi: this.moduleId === 2 && responseByModule.length > 0
						? responseByModule[0].purchase.subsidiary.companyId
						: responseByModule[0].sale.comCompanyId,
					subsidiaryIdApi: this.moduleId === 2 && responseByModule.length > 0
						? responseByModule[0].purchase.subsidiary.id
						: responseByModule[0].sale.comSubsidiaryId,
				},
				// codeAction: this.codeAction,
			};
			const seriesMap = new Map();
			const result =
				Array.from(seriesMap, ([serie, totalAmount]) =>
					({ codEstab: serie || 0, saleEstab: totalAmount.toFixed(2) }));
			const lastRecord = responseByModule[responseByModule.length - 1];
			const lastRecordDate = lastRecord && lastRecord.sale
				? new Date(lastRecord.sale.createdAt).getFullYear()
				: new Date(this.model.endDate).getFullYear();
			const lastRecordMonth = lastRecord && lastRecord.sale
				? (new Date(lastRecord.sale.createdAt).getMonth() + 1).toString().padStart(2, '0')
				: (new Date(this.model.endDate).getMonth() + 1).toString().padStart(2, '0');
			const valueProperty = this.moduleId === 1 ? 'details' : 'detailsPurchase';
			const body = responseByModule && responseByModule.length > 0 ?
				{
					/* eslint-disable no-nested-ternary */
					tipoIDInformante: this.moduleId === 1 && responseByModule.length > 0 ?
						(responseByModule[0].sale.subsidiaryRuc.length > 10 ? 'R' : 'C') : responseByModule[0].purchase.subsidiary.ruc.length > 10 ? 'R' : 'C',
					/* eslint-enable no-nested-ternary */
					ruc: this.moduleId === 1 && responseByModule.length ?
						responseByModule[0].sale.subsidiaryRuc :
						responseByModule[0].purchase.subsidiary.ruc,
					rzSocial: this.moduleId === 1 && responseByModule.length ?
						responseByModule[0].sale.subsidiaryRzSocial.trim() :
						responseByModule[0].purchase.subsidiary.rzSocial.trim(),
					year: String(lastRecordDate),
					month: String(lastRecordMonth),
					numEstabRuc: responseByModule.length && responseByModule[0].sale
						? responseByModule[0].sale.warehouseCodeTaxes
						: responseByModule[0].purchase.subsidiary.sucursalCode,
					totalSales: this.moduleId === 1 && responseByModule.length ?
						responseByModule
							.reduce((accumulator, obj) => {
								// Usar un acumulador temporal para calcular el subtotal de este objeto
								const subtotal = obj.sales.reduce(
									(subAcc, sale) => (
										sale.typeDocument.code === 'NTC'
											? subAcc - sale.subtotal // Restar si el code es "NTC"
											: subAcc + sale.subtotal // Sumar en otros casos
									),
									0,
								);
								return accumulator + subtotal; // Retornar el acumulador actualizado
							}, 0)
							.toFixed(2) : (0).toFixed(2),
					iva: 'IVA',
					[valueProperty]: newDetails,
					wareSales: result,
				} : {};
			body.code = this.report.code;
			const { data: responseReport } = await this.$http.post('/transactional-annexes-report', body, params);
			const blob = helper.generateBlob(responseReport);
			const urlObject = URL.createObjectURL(blob);
			const iFrame = document.createElement('iframe');
			iFrame.setAttribute('src', urlObject);
			iFrame.setAttribute('style', 'height:100vh;width:100%');
			const childNodes = this.$refs.viewer.childNodes;
			if (childNodes.length > 0) {
				this.$refs.viewer.removeChild(this.$refs.viewer.childNodes[0]);
			}
			this.$refs.viewer.append(iFrame);
			this.showPDF = true;
		} else {
			this.showNotification('No exite información para generar el PDF.', 'warning');
		}
	} catch (error) {
		this.showGenericError();
		this.showPDF = false;
	}
}

function data() {
	return {
		currentPage: 1,
		xmlDoc: '',
		dataError: [],
		rowsPurchases: [],
		flagSeeXml: false,
		rowsSales: [],
		openModalError: false,
		flagDisabled: false,
		openModalGenerateXml: false,
		formattedXml: '',
		disabledDoXml: true,
		seePdfXml: false,
		disabledSeeXml: true,
		highlightedXml: '',
		pdfBlobUrl: null,
		currentPageDetail: 1,
		checkAllAccounting: false,
		detailsRetRent: false,
		detailsRetIva: false,
		checkAll: false,
		columnsSales: [
			{
				id: 1,
				name: 'Nombre del cliente',
				tooltip: 'Fecha de Creación',
				value: 'account',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Nº de Identificación: ',
				value: 'name',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: 'T. de Comprobante ',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Nº de Comprobante',
				checked: true,
				visible: true,
				movil: true,
			},
			{ id: 5, name: 'Detalles', checked: true, visible: true, movil: true },
		],
		columnsPurchase: [
			{
				id: 1,
				name: 'Nombre del Proveedor',
				value: 'account',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Nº de Identificación: ',
				value: 'name',
				checked: true,
				visible: true,
			},
			{ id: 3, name: 'Detalles', checked: true, visible: true, movil: true },
		],
		columnsRetIva: [
			{
				id: 1,
				name: 'Monto Base',
				value: 'account',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Código Retención SRI ',
				value: 'name',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: '% Ret',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'V. Retenido',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		dialogLoading: false,
		itemsTotalQuantity: null,
		itemsTotalQuantityDetails: null,
		dialogDetailAccounting: false,
		dialogAction: false,
		dialogWait: false,
		detailJournalOpen: false,
		openMobile: false,
		flagDate: false,
		dataSelectedAccounting: [],
		dataSelected: [],
		codeSus: null,
		dataSelectedRet: null,
		dialogDeleteAccounting: false,
		listAccounting: true,
		lastPage: 0,
		lastPageDetails: 0,
		action: {
			code: '',
			title: '',
			value: false,
		},
		modules: [
			{ id: 1, name: 'Ventas' },
			{ id: 2, name: 'Compras' },
		],
		moduleId: null,
		model: {
			limit: 20,
			search: null,
			moduleId: null,
			stateId: 'pending',
			startDate: null,
			endDate: null,
			onSearch: null,
			status: null,
			accountingSeat: null,
			square: 1,
		},
		mobile: false,
		nameAccouting: null,
		showDetailAccounting: false,
		rowsDetails: [],
		rowsDetailModal: [],
		rows: [],
		rowsSeat: [],
		showAccouting: false,
		titleDialogDelete: '',
		flagStateRecord: true,
		valuesShow: {},
		modulesFilter: [],
		columnsError: [
			{
				id: 1,
				name: 'Proveedor',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Fecha de la Compra',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Numero de Documento',
				checked: true,
				visible: true,
				movil: true,
			},
		],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ayer' },
			{ id: 3, name: 'Ultima Semana' },
			{ id: 4, name: 'Mes Actual' },
			{ id: 5, name: 'Año Actual' },
			{ id: 6, name: 'Rangos de Fechas' },
		],
		openModal: false,
		listCodes: [],
		isLoading: false,
		// Variables para compras
		dateEmission: null,
		TaxDifZero: 0,
		TaxZero: 0,
		detailsRetServices: null,
		accountingSeat: null,
		sumBaseZeo: 0,
		sumBaseIva: 0,
		fileName: '',
		codeAction: null,
		// Varaibles para realizar los reportes
		typeReports: [
			{ id: 1, name: 'Resumen Ventas ATS', code: 'ats_sales_summary' },
			{ id: 2, name: 'Resumen Retenciones Ventas', code: 'ats_sales_retention_summary' },
			{ id: 3, name: 'Resumen Compras ATS', code: 'ats_purchase_summary' },
			{ id: 4, name: 'Resumen Retenciones Compras', code: 'ats_purchase_retention_summary' },
		],
		filterTypeReports: [],
		report: null,
		showPDF: false,
		rowId: null,
	};
}

export default {
	name: 'page-accouting-ats-sales',
	created,
	data,
	destroyed,
	components: {
		actionBar,
		appTooltipButton,
		appDateSelect,
		dateComponent,
		BaseSelect,
		actionSidebar,
		listHistoryAts,
		atsSalesDetails,
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		atsPurchasesDetails,
		appInputText,
	},
	computed: {
		...mapGetters('subsidiary', ['currentSubsidiary']),
	},
	methods: {
		changePage,
		getDataDate,
		getTypeDocument,
		closeModalxml,
		closeModalError,
		verifyDowloadXml,
		clearAccouting,
		getDate,
		seeXml,
		DowloadXml,
		loadModules,
		closeModal,
		loadCodSusList,
		loadPurchase,
		changeFlag,
		closeMobile,
		seeXmlPurchasesSales,
		runAction,
		setDataAuth,
		openDetail,
		reziseMobile,
		seeDetails,
		formatDate,
		getDataModule,
		getTypeReports,
		downloadReport,
	},
};
</script>

<style lang="scss" scoped>
.xml-content {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  padding: 20px;
  overflow: auto;
}
.captionDateModal {
	font-size: 10px;
	text-align: center;
	color: black !important;
	font-family: 'AvenirRegular';
}
.formatted-xml {
  white-space: pre-wrap;
  font-family: monospace;
}
.btn-accounting {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	font-family: map-get($fonts, AvenirRegular) !important;
	font-size: 12px !important;
	font-weight: 600;
	text-transform: capitalize !important;
	width: 100% !important;

	@media (max-width: 1024px) {
		width: 100%;
	}
}
.message-box {
	background-color: color(white);
	box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.07);
	border-radius: 10px;
	border: PowderBlue 5px solid;
	font-family: font(open-bold);
	position: relative;
	width: 100%;
	padding: 5px 5px;
}
.btnSaveAccounting {
	color: white !important;
}
#column-6 {
	span {
		color: red !important;
	}
}
.titleNumberSeat {
	color: #02979b !important;
	font-family: 'Avenir Regular', Arial, sans-serif;
	font-weight: bold;
}
.loading-search {
	color: white !important;
	font-family: map-get($fonts, AvenirDemi) !important;
	font-size: 14px !important;
	text-align: center;
}

.content-dialog {
	box-shadow: none !important;
}

.blue-debe {
	color: #006edb;
	font-family: map-get($fonts, AvenirBold);
	font-size: 11px;
}
.captionDate {
	font-size: 10px;
	text-align: center;
	font-family: 'AvenirRegular';
}
.red-haber {
	color: #ff0000;
	font-family: map-get($fonts, AvenirBold);
	font-size: 11px;
}

.btn {
	border-radius: 30px;
	color: white;
	height: 30px;
	padding: 0 10px;
	width: 90px;
}

.agree {
	background-color: color(secondary);
	margin-left: 10px;
}

.cancel {
	background-color: color(error);
	margin-right: 10px;
}

.show-mobile {
	@media (max-width: 890px) {
		padding: 8px !important;
	}
}
.wrapper-detail {
	@media (max-width: 768px) {
		display: none;
	}
}
.content-open {
	background-color: #e0e5e8;
	font-weight: 200;
	padding: 5px 0px;
	font-family: 'AvenirBold';
	font-size: 12px;
}
.btnLoadExcel {
	height: 35px;
	font-size: 10px;
	border-radius: 5px;
	text-align: center;
}

.content-open-btn {
	background-color: #e0e5e8;
	font-weight: 200;
	padding: 5px 10px;
	font-family: 'AvenirBold';
	font-size: 12px;
	display: flex;
	justify-content: space-between; /* Distribuye el texto a la izquierda y el botón a la derecha */
	align-items: center;
}

.row-mobile {
	@media (min-width: 1024px) {
		padding: 0 24px;
	}
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/8;
		grid-row: 2;
		white-space: nowrap;
	}
}

.reference {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/7;
		grid-row: 2;
		white-space: nowrap;
	}
}
.titleModal {
	font-size: 25px;
	text-align: center;
	color: black !important;
	font-family: 'AvenirRegular';
}
.entity {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/5;
		grid-row: 2;
		white-space: nowrap;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}
.selected-cell {
	background-color: #e3f2fd !important; 
}

.content-acc {
	@media (max-width: 768px) {
		left: -100%;
		position: absolute;
		transition: all 0.2s ease-in-out 0s;
		z-index: 2;

		&.open {
			left: 0;
			width: 100%;
		}
	}
}
.content-label {
	color: #2c404a;
	background-color: #e0e5e8;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 12px;
	font-weight: 500;
}

.content-text {
	background-color: white;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 12px;
}
.loading-icon {
	display: inline-flex;
	align-items: center;
}


// .dialog-container {
// 	background-color: #f9f9f9;
// 	border: 1px solid #ccc;
// 	border-radius: 8px;
// 	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
// 	display: none;
// 	flex-direction: column;
// 	align-items: center;
// }

.spinner {
	border: 4px solid rgba(0, 0, 0, 0.1);
	border-top: 4px solid #3d989b;
	border-radius: 100%;
	width: 60px;
	height: 40px;
	margin: 20px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.titleWait {
	font-family: 'Avenir Regular', Arial, sans-serif;
	font-size: 20px;
	font-weight: bold;
	display: inline-block;
	margin: 0;
}
.text-card {
	border-radius: 10px;
	background-color: #e6e2e2;
}

.scrollable-table {
  max-height: 600px;
  overflow-y: auto;
}
.section-actions {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 15px;
}
.btn-modal {
	max-width: 150px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/atsSales/ats-sales.vue